const DefaultThoughts = [
    {
        _id: 1,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 2,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 3,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 4,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 5,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 6,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 7,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 8,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    },
    {
        _id: 9,
        message: 'I am happy today',
        hearts: 100,
        createdAt: '2022-03-25T14:47:13.466Z',
    }
]

export default DefaultThoughts;